import React from "react";
import { Checkbox } from "components/ui/checkbox";
import { Label } from "components/ui/label";
import { Input } from "components/ui/input";
import { AssetTypeOption, MeterRole } from "./types";

interface MeterRoleRowProps {
  role: MeterRole;
  assetTypes: AssetTypeOption[];
  onChange: (role: MeterRole) => void;
}

/**
 * One document meter role (e.g. "Elektriciteit") plus the voorziening-types
 * that should be treated as that role when generating documents.
 */
export const MeterRoleRow: React.FC<MeterRoleRowProps> = ({ role, assetTypes, onChange }) => {
  const toggleType = (typeId: number, checked: boolean) => {
    const assetTypeIds = checked
      ? [...role.assetTypeIds, typeId]
      : role.assetTypeIds.filter((id) => id !== typeId);
    onChange({ ...role, assetTypeIds });
  };

  return (
    <div className="flex flex-col gap-2 border border-border rounded-md p-3">
      <Input
        aria-label="Naam document-rol"
        value={role.label}
        onChange={(e) => onChange({ ...role, label: e.target.value })}
        className="max-w-xs font-medium"
      />

      <div className="flex flex-col gap-1.5 pl-1">
        <span className="text-xs text-muted-foreground">Voorziening-types</span>
        {assetTypes.length === 0 ? (
          <span className="text-xs text-muted-foreground italic">
            Geen meter-types gevonden in de categorie "Meters".
          </span>
        ) : (
          <div className="flex flex-wrap gap-x-6 gap-y-2">
            {assetTypes.map((type) => {
              const id = `role-${role.key}-type-${type.id}`;
              const checked = role.assetTypeIds.includes(type.id);
              return (
                <div key={type.id} className="flex items-center gap-2">
                  <Checkbox
                    id={id}
                    checked={checked}
                    onCheckedChange={(value) => toggleType(type.id, value === true)}
                  />
                  <Label htmlFor={id} className="text-sm font-normal cursor-pointer">
                    {type.name}
                  </Label>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default MeterRoleRow;
